import { Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

import { PRESENTATION_VARIABLE_CLASS } from '@/components/TextEditor/plugins/PresentationVariablePlugin/PresentationVariableNode';
import { COLORS } from '@/styles/tokens/colors';

export const SLIDE_EDITOR_HOVER: SystemStyleObject<Theme> = {
  cursor: 'text',
  // Shrink-wrap the border around the title text
  width: 'fit-content',
  borderRadius: '1px',
  // Use outline instead of border so the hover effect has
  // zero layout impact — no margin/padding compensation needed.
  // outlineOffset adds visual breathing room between the content
  // and the border.
  '&:hover': {
    outline: `1px solid ${COLORS.BLUE[600]}`,
    outlineOffset: '3px',
  },
};

export const VARIABLE_HIGHLIGHT_STYLES = {
  backgroundColor: COLORS.NAVY[50],
  // inset box-shadow renders as a border without affecting layout
  boxShadow: `inset 0 0 0 1px ${COLORS.NAVY[100]}`,
  color: COLORS.BLUE[600],
};

/** Always show the variable highlight (template / edit mode). */
export const VARIABLE_HIGHLIGHT_SX: SystemStyleObject<Theme> = {
  [`& .${PRESENTATION_VARIABLE_CLASS}`]: VARIABLE_HIGHLIGHT_STYLES,
};

/** Show the variable highlight only on hover (live presentation flow). */
export const VARIABLE_HIGHLIGHT_HOVER_SX: SystemStyleObject<Theme> = {
  [`&:hover .${PRESENTATION_VARIABLE_CLASS}`]: VARIABLE_HIGHLIGHT_STYLES,
};
